package org.wordsapp.data

import org.wordsapp.model.Word

fun getDemoWords(): List<Word> = listOf(
    Word(id = 1, foreignWord = "hello", translation = "привет", correctAnswers = 3, incorrectAnswers = 1, rowIndex = 2),
    Word(id = 2, foreignWord = "world", translation = "мир", correctAnswers = 2, incorrectAnswers = 2, rowIndex = 3),
    Word(id = 3, foreignWord = "cat", translation = "кот", correctAnswers = 5, incorrectAnswers = 0, rowIndex = 4),
    Word(id = 4, foreignWord = "dog", translation = "собака", correctAnswers = 1, incorrectAnswers = 3, rowIndex = 5),
    Word(id = 5, foreignWord = "house", translation = "дом", correctAnswers = 4, incorrectAnswers = 1, rowIndex = 6),
    Word(id = 6, foreignWord = "book", translation = "книга", rowIndex = 7),
    Word(id = 7, foreignWord = "water", translation = "вода", rowIndex = 8),
    Word(id = 8, foreignWord = "fire", translation = "огонь", correctAnswers = 0, incorrectAnswers = 2, rowIndex = 9),
    Word(id = 9, foreignWord = "tree", translation = "дерево", correctAnswers = 1, incorrectAnswers = 0, rowIndex = 10),
    Word(id = 10, foreignWord = "sun", translation = "солнце", rowIndex = 11),
)
